import {Component, Event, EventEmitter, h, Host, State} from '@stencil/core';
import eticketsIcon from '../../../assets/icons/etickets.svg';
import Infomaniak from "../../../assets/logo/infomaniak.svg";
import {endpoint_api, endpoint_portal, getRandomInt, translate} from "../../../utils/utils";
import {DateTime} from 'luxon';
import axios from 'axios';

@Component({
  tag: 'ike-queue',
  styleUrl: 'ike-queue.scss',
  shadow: false,
})
export class IkeQueue {
  @State() config: any;
  @State() cart: any;
  @State() progress = 0.0;
  @State() timetoend = -1;

  private utils: any;
  private unsub = [];
  private first = -1;
  private has_cookie:boolean = true;
  private begin:any;
  private interval:any;
  private pingInter;

  @Event() getUtils: EventEmitter;

  componentWillLoad() {
    if (!navigator.cookieEnabled){
      this.has_cookie = false;
    }
    this.begin = DateTime.local();
    this.getUtils.emit(utils=>this.utils=utils);
    this.unsub.push(this.utils.config(config => this.config = config));
    this.unsub.push(this.utils.cart(cart => {
      this.cart = cart
      if(cart){
        if(this.first === -1 || this.first<cart.rank){
          this.first = cart.rank;
        }
        let done = this.first-cart.rank;
        let elapsed = DateTime.local().diff(this.begin).toObject().milliseconds

        if(done){
          this.timetoend = elapsed*cart.rank/done
        }

        this.progress = Math.round(100*100*(done)/this.first)/100;
      }
    }));
    this.pingInter = setInterval(()=>axios.get(endpoint_api+'/kueue-ping', {
      headers: {
        'kueue': sessionStorage.getItem('kueue') || '',
      },
      withCredentials: true
    }), getRandomInt(20,40)*1000);
    this.interval = setInterval(()=>{
      this.utils.http('get', '/cart').then(cart=>{
        this.utils.store.set('cart', cart)
        if (cart.kueue) {
          sessionStorage.setItem('kueue', cart.kueue);
        }
      })
    }, 5*1000)
  }

  disconnectedCallback(){
    this.unsub.forEach(call=>call())
    clearInterval(this.interval);
    clearInterval(this.pingInter);
  }

  render() {
    return <Host>
      <div class="queue-jumbotron">
        {this.config?.queue_img &&
          <div class="queue-logo"><img src={this.config?.queue_img} alt={this.config?.period_name}/></div>
        }

        {this.config.period_count == 1 && !this.config?.queue_img &&
          <h2 class="queue-name title-3">{this.config?.period_name}</h2>
        }
        {this.has_cookie &&
          <div>
            {this.config?.kustom_kueue_text > 0 &&
              <div>
                <div class="queue-title title-2">{translate("Bienvenue dans la file d'attente de la billetterie de la coupe du monde de biathlon Annecy - Le Grand-Bornand.")}</div>
                <div class="queue-text margin-bottom-20">
                  {translate("Vous etes nombreux a vouloir nous retrouver pour vivre ensemble la coupe du monde et nous vous en remercions. Afin de garantir le bon deroulement des reservations et de gerer au mieux le nombre d'utilisateurs simultanes maximum possible dans la billetterie en ligne, une file d'attente a ete mise en place. Une fois dans la billetterie vous aurez 20 minutes pour effectuer votre commande. Ne quittez pas cette page, elle est actualisee automatiquement toutes les 15 secondes.")}
                </div>
              </div>
            }
            {!this.config?.kustom_kueue_text &&
              <div>
                <div class="queue-title title-2">{translate("Vous etes maintenant dans la file d'attente")}</div>
                <div class="queue-text margin-bottom-20">
                  {translate("Beaucoup de personnes souhaitent acceder a la boutique.")}&nbsp;
                  {translate("Les demandes sont traitees par ordre d'arrivee.")}&nbsp;
                  {((parts => [parts[1],
                    <strong>{parts[2]}</strong>, parts[3]])(/^(.*?)\[START_BOLD](.*?)\[END_BOLD](.*?)$/.exec(
                    translate("Quand vous entrerez, [START_BOLD]vous aurez {x} minutes pour effectuer votre commande[END_BOLD].", {x: 20})
                  )))}
                  <br/>
                  {translate("Ne quittez pas cette page.")}
                </div>
              </div>
            }
            <div class="queue-progress">
              {this.cart?.rank > 0 &&
                <div>
                  <div class="queue-progress__toptext">{translate("Merci de patienter...")}</div>
                  <div class="queue-progress__bar">
                    <div class="queue-progress__bar--inner" style={{width: this.progress + '%'}}>
                      <div class="queue-progress__bar--inner-anim"/>
                    </div>
                  </div>
                  <div class="queue-progress__bottomtext">
                    {translate("Encore {x} personnes devant vous", {x: this.cart?.rank})}
                  </div>
                </div>
              }
              {this.cart?.rank === 0 &&
                <div class="queue-progress__bottomtext margin-top-60 font-size-18">
                  🎉 {translate("Vous etes le prochain a avoir acces a la billetterie", {x: this.cart?.rank})} 🎉
                </div>
              }
            </div>
          </div>
        }
        {!this.has_cookie &&
          <div>
            <div class="queue-title title-2">{translate("File d'attente")}</div>
            <div class="queue-text margin-bottom-20">
              <a target={'_blank'} class="button primary btn-lg margin-bottom-10" href={this.utils.getEnableCookieLink()}>{translate("Veuillez activer les cookies pour acceder a la file d'attente de la billetterie")}</a>
              <p>{translate("Nous utilisons les cookies sur votre navigateur afin de pouvoir identifier votre position dans la file d'attente.")}</p>
            </div>
          </div>
        }
        <div class="queue-footer">
          <div class="queue-footer__logo"><img class="colorizeIcon" src={eticketsIcon} alt={translate('billetterie')} /></div>
          <p class="queue-footer__text text-4">powered by&nbsp;<a target={'_blank'} href={`${endpoint_portal}`}><img src={Infomaniak} alt="Infomaniak"/></a></p>
        </div>
      </div>
    </Host>;
  }
}
